import { render, staticRenderFns } from "./CloudDevopsServices.vue?vue&type=template&id=87cc6d5c&scoped=true&"
import script from "./CloudDevopsServices.vue?vue&type=script&lang=js&"
export * from "./CloudDevopsServices.vue?vue&type=script&lang=js&"
import style0 from "./CloudDevopsServices.vue?vue&type=style&index=0&id=87cc6d5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc6d5c",
  null
  
)

export default component.exports